/**
 * Test ids hang off the parent: `login-email`, then `login-email-label`,
 * `login-email-control`. A missing parent means no attribute at all — screens
 * that have not named a control yet must not emit empty or orphan ids.
 */

export function testIdFor(parent: string | undefined, slot: string): string | undefined {
  return parent ? `${parent}-${slot}` : undefined;
}

export function testIdAttr(id: string | undefined): { 'data-testid'?: string } {
  return id ? { 'data-testid': id } : {};
}
